export type MaintenancePageTranslation = {
  defaultMessage: string;
  expectedCompletion: string;
  maintenanceWork: string;
  thankYouMessage: string;
};

export const maintenancePageTranslation: MaintenancePageTranslation = {
  defaultMessage: 'Trwają prace serwisowe. Przepraszamy za niedogodności.',
  expectedCompletion: 'Planowane zakończenie:',
  maintenanceWork: 'Prace serwisowe',
  thankYouMessage: 'Dziękujemy za cierpliwość. System zostanie wkrótce przywrócony.',
};
